import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Layer,
  Loading,
  Pane,
  PaneFooter,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import CategoryFormFields from './CategoryFormFields';

const propTypes = {
  categoryId: PropTypes.string,
  localizedName: PropTypes.string,
  onClose: PropTypes.func,
  initialValues: PropTypes.object,
  onHandleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};

function CategoryForm({
  categoryId,
  localizedName,
  onClose,
  initialValues,
  onHandleSubmit,
  isLoading,
}) {
  const renderPaneFooter = (submit, pristine, submitting) => {
    return (
      <PaneFooter
        renderEnd={
          <Button
            buttonStyle="mega primary"
            disabled={pristine || submitting}
            id="create-new-customField-category-pane-footer-submit-btn"
            marginBottom0
            type="submit"
            onClick={(event) => {
              submit(event);
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-components.saveAndClose"
              defaultMessage="Save and close"
            />
          </Button>
        }
        renderStart={
          <Button
            buttonStyle="mega primary"
            id="create-new-customField-category-pane-footer-previous-btn"
            marginBottom0
            onClick={onClose}
          >
            <Icon icon="times-circle-solid">
              <FormattedMessage
                id="stripes-components.cancel"
                defaultMessage="Previous: {prevPage}"
              />
            </Icon>
          </Button>
        }
      />
    );
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, values }) => {
        return (
          <form
            id="new-inventory-templates-customField-category-form"
            onSubmit={handleSubmit}
          >
            <Layer contentLabel="Edit inventory template custom fields category" isOpen>
              <Pane
                id="inventory-templates-plugin-custom-fields-category-form-pane"
                defaultWidth="fill"
                paneTitle={
                  categoryId ? (
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.customFields.categoryForm.edit.pane.paneTitle"
                      values={{ categoryName: localizedName }}
                      defaultMessage="Edit {categoryName} field"
                    />
                  ) : (
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.customFields.categoryForm.create.pane.paneTitle"
                      defaultMessage="Create new custom field category"
                    />
                  )
                }
                dismissible
                onClose={onClose}
                footer={renderPaneFooter(handleSubmit, pristine, submitting)}
              >
                {isLoading && <Loading size="large" />}

                {!isLoading && <CategoryFormFields />}
                {/* <hr />
                <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </Pane>
            </Layer>
          </form>
        );
      }}
    </Form>
  );
}

CategoryForm.propTypes = propTypes;

export default CategoryForm;
